import { observable, autorun, action } from 'mobx';
import { executeFnByCount } from '../../js/utils';

export const BUFFER_NUM = 6;

const buffer = {};
executeFnByCount(BUFFER_NUM, (num) => {
  buffer[`buffer${num}`] = '';
});

export default class CmdBufferStore {
  @observable buffer = Object.assign({}, buffer);

  @action init() {
    let lsData = localStorage.getItem('cmdBuffer');

    if (lsData) {
      lsData = JSON.parse(lsData);
      Object.keys(this.buffer).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(lsData, key)) {
          this.buffer[key] = lsData[key];
        }
      });
    }
  }
}

export const cmdBufferStore = new CmdBufferStore();

let first = true;

// 每次更新都进行本地存储更新
// JSON.stringify会序列化可枚举的对象属性，所以肯定会访问对象的属性，所以当对象属性改变时会触发autorun
autorun(() => {
  if (first) {
    // 默认初始会执行一次，确保刷新页面或重新打开页面首先从localStorage中更新
    cmdBufferStore.init();
    first = false;
  }
  localStorage.setItem('cmdBuffer', JSON.stringify(cmdBufferStore.buffer));
});
